export const NAMESPACE = 'creditNote'
